/**
 * RequestPasswordReset component.
 * @module components/theme/RequestPasswordReset/RequestPasswordReset
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { BodyClass, Helmet } from '@plone/volto/helpers';
import { Button, Container, Form, Segment } from 'semantic-ui-react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';

import { resetPassword } from '@plone/volto/actions';

const messages = defineMessages({
  resetPassword: {
    id: 'Reset Password',
    defaultMessage: 'Reset Password',
  },
  passwordReset: {
    id: 'Password reset',
    defaultMessage: 'Password reset',
  },
});

/**
 * RequestPasswordReset class.
 * @class RequestPasswordReset
 * @extends Component
 */
class RequestPasswordReset extends Component {
  /**
   * Property types.
   * @property {Object} propTypes Property types.
   * @static
   */
  static propTypes = {
    loading: PropTypes.bool.isRequired,
    loaded: PropTypes.bool.isRequired,
    error: PropTypes.string,
    resetPassword: PropTypes.func.isRequired,
  };

  /**
   * Default properties.
   * @property {Object} defaultProps Default properties.
   * @static
   */
  static defaultProps = {
    error: null,
  };

  /**
   * Constructor
   * @method constructor
   * @param {Object} props Component properties
   * @constructs Controlpanel
   */
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);

    this.state = {
      isSuccessful: false,
    };
  }

  /**
   * Component will receive props
   * @method componentWillReceiveProps
   * @param {Object} nextProps Next properties
   * @returns {undefined}
   */
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.loading && nextProps.loaded) {
      this.setState({ isSuccessful: true });
    }
  }

  /**
   * Submit handler
   * @method onSubmit
   * @param {object} data Form data.
   * @param {object} event Form data.
   * @returns {undefined}
   */
  onSubmit(event) {
    this.props.resetPassword(document.getElementsByName('login')[0].value);
    event.preventDefault();
  }

  /**
   * Render method.
   * @method render
   * @returns {string} Markup for the component.
   */
  render() {
    if (this.state.isSuccessful) {
      return (
        <div className="full-width background-grey" id="page-password-reset">
          <Helmet
            title={this.props.intl.formatMessage(messages.passwordReset)}
          />
          <BodyClass className="background-grey" />
          <Container>
            <div className="form">
              <Segment>
                <h1 className="documentFirstHeading">
                  <FormattedMessage
                    id="Password reset sent!"
                    defaultMessage="Password reset sent!"
                  />
                </h1>
                <p className="description">
                  <FormattedMessage
                    id="description_sent_password"
                    defaultMessage="Your password reset request has been mailed. It should arrive in your mailbox shortly. When you receive the message, visit the address it contains to reset your password."
                  />
                </p>
              </Segment>
            </div>
          </Container>
        </div>
      );
    }

    return (
      <div className="full-width background-grey" id="page-password-reset">
        <Helmet title={this.props.intl.formatMessage(messages.passwordReset)} />
        <BodyClass className="background-grey" />
        <Container>
          <Form method="post" className="form" onSubmit={this.onSubmit}>
            <Segment raised>
              <h1>
                <FormattedMessage
                  id="Forgot your password?"
                  defaultMessage="Forgot your password?"
                />
              </h1>
              <Form.Field>
                <label htmlFor="login">
                  <FormattedMessage id="Email" defaultMessage="Email" />
                </label>
                <input
                  id="login"
                  name="login"
                  placeholder="e.g. john@do.com"
                  autoFocus
                />
              </Form.Field>
              <div className="button-bar">
                <Button
                  primary
                  className="rounded"
                  type="submit"
                  id="login-form-submit"
                  aria-label={this.props.intl.formatMessage(
                    messages.resetPassword,
                  )}
                  title={this.props.intl.formatMessage(messages.resetPassword)}
                  loading={this.props.loading}
                >
                  <FormattedMessage
                    id="Reset Password"
                    defaultMessage="Reset Password"
                  />
                </Button>
              </div>
            </Segment>
          </Form>
        </Container>
      </div>
    );
  }
}

export default compose(
  withRouter,
  injectIntl,
  connect(
    (state) => ({
      loading: state.users.reset.loading,
      loaded: state.users.reset.loaded,
      error: state.users.reset.error,
    }),
    { resetPassword },
  ),
)(RequestPasswordReset);
